import { render, staticRenderFns } from "./TeamSideBar.vue?vue&type=template&id=3aeddddc&scoped=true"
import script from "./TeamSideBar.vue?vue&type=script&lang=js"
export * from "./TeamSideBar.vue?vue&type=script&lang=js"
import style0 from "./TeamSideBar.vue?vue&type=style&index=0&id=3aeddddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeddddc",
  null
  
)

export default component.exports